$(function() {
    select2 = 'select2';
    helperClasses.init();

    //components
    vacancyBlock.init();
    eventSearchHeaderBlock.init();
    navBarBlock.init();
    accordionBlock.init();
    faqBlock.init();
    amountBlock.init();
    selectUrlBlock.init();
    modalBlock.init();
    singleEventBlock.init();
    routeBlock.init();
    googleMap = routeBlock;
    subnavBlock.init();
    formStylingBlock.init();
    headerBackground.init();
    busDriverLandingspage.init();
    /*    woocommerceCheckout.init(); TODO: CustomEvent na ajax call*/
});
